module.exports = __webpack_public_path__ + "img/apple_pay.3cd749a1.svg";